import { useState } from 'react';
import { Dialog, DialogTitle, DialogActions } from '@mui/material';
import { H2, Subtitle1 } from '../../components/typography/typography';
import { PrimaryButton, SecondaryButton } from '../../components/buttons/buttons';
import { useTranslation } from 'react-i18next';

const useDeleteDialog = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [item, setItem] = useState('');
  const [resolver, setResolver] = useState<((value: boolean) => void) | null>(null);

  const confirmDelete = (item = '') => new Promise<boolean>(resolve => {
    setIsOpen(true);
    setItem(item);
    setResolver(() => resolve);
  });

  const handleConfirm = () => {
    setIsOpen(false);
    if (resolver) resolver(true);
  };

  const handleClose = (_event: any, reason: string) => {
    // Allow closing on backdrop click and escape key
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      setIsOpen(false);
      if (resolver) resolver(false);
    }
  };

  const DeleteModal = (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      PaperProps={{
        sx: {
          backgroundColor: 'background.white',
          borderRadius: 2,
          padding: 2,
          border: '1px solid rgba(0, 0, 0, 0.1)',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(30, 30, 30, 0.75)',
          backdropFilter: 'blur(4px)',
        },
      }}>

      <DialogTitle sx={{ fontSize: (theme: any) => theme.typography.fontSizes.heading2, fontWeight: 600, color: 'text.darkGrey', textAlign: 'center' }}>
        <H2> {t('Are you sure you want to delete?')} </H2>
        <Subtitle1> {item} </Subtitle1> 
      </DialogTitle>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <SecondaryButton fullWidth onClick={() => setIsOpen(false)}> {t('Cancel')} </SecondaryButton>
        <PrimaryButton sx={{backgroundColor: 'background.red'}} fullWidth onClick={() => handleConfirm()}> {t('Delete')} </PrimaryButton>
      </DialogActions>
    </Dialog>
  );

  return { confirmDelete, DeleteModal };
};

export default useDeleteDialog;
